import { render, staticRenderFns } from "./AssetMainFull.vue?vue&type=template&id=fb4c71da"
import script from "./AssetMainFull.vue?vue&type=script&lang=js"
export * from "./AssetMainFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports